import React, { useCallback, useEffect, useLayoutEffect, useRef, useState, } from 'react';
import { getScrollContainer } from '@/utils/dom';
/**
 * @category 组件
 * @description 固钉
 */
export const CnAffix = (prop) => {
    const { children, container, disabled, offsetTop, zIndex, onAffix } = prop;
    const boxRef = useRef(null);
    const contentRef = useRef(null);
    const boxElement = boxRef?.current;
    const contentElement = contentRef?.current;
    const [boxStyles, seBoxStyles] = useState({});
    const [contentStyles, setContentStyles] = useState({});
    const [contentTop, setContentTop] = useState(0);
    const [contentHeight, setContentHeight] = useState(0);
    const [boxTop, setBoxTop] = useState(0);
    const containerRef = useRef(null);
    // 滚动监听器
    const scrollHandler = useCallback(() => {
        const currentBoxTop = boxElement?.getBoundingClientRect()?.top;
        const currentContentTop = contentElement?.getBoundingClientRect()?.top;
        const currentContentHeight = contentElement?.getBoundingClientRect()?.height;
        setBoxTop(currentBoxTop || 0);
        setContentTop(currentContentTop || 0);
        setContentHeight(currentContentHeight || 0);
    }, [boxElement, contentElement]);
    /**
     * 用于处理content变成fixed定位脱离文档流，导致父级box高度为0
     */
    useLayoutEffect(() => {
        seBoxStyles({
            height: contentElement?.getBoundingClientRect()?.height,
        });
    }, [contentElement]);
    useEffect(() => {
        containerRef.current = getScrollContainer(container);
    }, [container]);
    useLayoutEffect(() => {
        const style = {
            zIndex,
        };
        let isFixed = false;
        if (disabled)
            return style;
        const offsetTopNum = Number(offsetTop);
        if (containerRef.current) {
            const containerTop = containerRef.current?.getBoundingClientRect()?.top;
            const containerHeight = containerRef.current?.getBoundingClientRect()?.height;
            if (containerHeight + containerTop < offsetTopNum + contentHeight) {
                style.transform = `translate3d(0, ${containerHeight - contentHeight}px, 0)`;
            }
            else if (boxTop <= offsetTopNum) {
                style.position = 'fixed';
                style.top = `${offsetTopNum}px`;
                isFixed = true;
            }
        }
        else if (boxTop <= offsetTopNum) {
            style.position = 'fixed';
            style.top = `${offsetTopNum}px`;
            isFixed = true;
        }
        onAffix && onAffix({ scrollTop: contentTop, isFixed });
        setContentStyles(style);
        // 这里只需要监听boxTop，不需要全部监听
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [boxTop]);
    useEffect(() => {
        addEventListener('scroll', scrollHandler);
        return () => {
            removeEventListener('scroll', scrollHandler);
        };
    }, [boxTop, contentTop, contentHeight, scrollHandler]);
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { ref: boxRef, className: "cn-ui-m-affix", style: boxStyles },
            React.createElement("div", { ref: contentRef, className: "cn-ui-m-affix-content", style: contentStyles }, children))));
};
CnAffix.displayName = 'CnAffix';
CnAffix.defaultProps = {
    container: 'body',
    disabled: false,
    offsetTop: 0,
    zIndex: 99,
};
